import { useMemo } from "react";
import { useContentSetting } from "./ContentSetting";
import { s3baseUrl } from "../config/config";

/** Same rules as AppSidebar: only URLs/names from portal_setting (no default logo). */
export function usePortalBrand() {
  const { userInfo } = useContentSetting();
  return useMemo(() => {
    const ps = userInfo?.portal_setting;
    const brandName = (ps?.brand_name && String(ps.brand_name).trim()) || "";
    const brandLogoUrl =
      ps?.brand_logo && String(ps.brand_logo).trim()
        ? s3baseUrl + ps.brand_logo
        : "";
    return { brandName, brandLogoUrl };
  }, [userInfo?.portal_setting?.brand_name, userInfo?.portal_setting?.brand_logo]);
}
